
export enum DayShutter {
    OneFifth, // 1/5
    OneTenth, // 1/10
    OneTwentyFifthOrOneThirtieth, // 1/25 or 1/30
    OneFiftiethOrOneSixtieth, // 1/50 or 1/60
    OneHundredthOrOneOneHundredTwentieth, // 1/100 or 1/120
    OneTwoHundredFiftieth, // 1/250
    OneFiveHundredth, // 1/500
    OneSevenHundredFiftieth, // 1/750
    OneThousandth, // 1/1000
    OneTwoThousandth, // 1/2000
    OneFourThousandth, //  1/4000
    OneTenThousandth, //  1/10000
    OneHundredThousandth, //  1/100000
    One, // 1
}

export enum DayStatus {
    Off,
    On,
}

export enum DayNightColorMode {
    BWMode,
    ColorMode,
}

export interface PTZCameraDayNight {
    DayExposureLevel: number;
    DayMinShutter: DayShutter;
    DayMaxShutter: DayShutter;
    DayLimitGain: number;
    DayIrCutInterval: number;
    DayIrCutStatus: DayStatus;
    DayIrLedStatus: DayStatus;
    DayWhiteLedStatus: number;
    DayColorMode: DayNightColorMode;
    NightExposureLevel: number;
    NightMinShutter: number;
    NightMaxShutter: number;
    NightLimitGain: number;
    NightIrCutStatus: number;
    NightIrLedStatus: number;
    NightWhiteLedStatus: number;
    NightColorMode: DayNightColorMode;
    NightIrCutInterval: number;
}

